import { useBrand } from "./BrandProvider";

// F-MOTOR-RESERVAS.3.0.3 — Componente oficial do logo Rede Hospeda.
// Substitui todas as instâncias do ícone `Mountain` placeholder e do wordmark Sacramento.
// Props:
//   variant = "full" (horizontal com texto, padrão) | "mark" (apenas símbolo) | "white" (monocromático branco)
//   size    = número em px (altura). Default 36.
//   className = classes extras do container
export function BrandMark({ variant = "mark", size = 36, className = "", alt }) {
  const brand = useBrand();
  const src =
    variant === "full" ? brand.assets.logo :
    variant === "white" ? brand.assets.logoWhite :
    brand.assets.logoMark;

  const label = alt || brand.name;
  // Para variante "full" o SVG é horizontal (~2.56:1); mantemos h fixo e w auto.
  // Para "mark" é quase quadrado (~1.16:1); também usamos h fixo.
  return (
    <img
      src={src}
      alt={label}
      height={size}
      style={{ height: `${size}px`, width: "auto" }}
      className={className}
      draggable="false"
    />
  );
}

export function BrandWordmark({ className = "" }) {
  const brand = useBrand();
  return (
    <span
      className={className}
      style={{ fontFamily: "var(--brand-font-title)", fontWeight: 700, letterSpacing: "-0.015em" }}
    >
      {brand.name}
    </span>
  );
}
